# Recovery review

What recovery **would** do. Nothing here changes your source files.

Cells are sorted into lanes by the source profile:

- **Auto** — the profile approves this field for backfill and the value is
  restorable, so it is applied and recorded.
- **Review** — your call. Each needs a reason, which the audit records.
- **Ineligible** — the reference has no value to restore, so there is nothing
  to decide.

Decisions are append-only: changing your mind adds an entry rather than
replacing one, because the history is the audit trail.

## The export gate

A recovered export can be blocked — by the match-rate floor, or because a draft
profile governs the run. A draft approves nothing, and the per-source gate
switches cannot release it: those exist for approved policy.

Reports and audits are never gated, so a blocked run still produces its full
evidence.

## Handing it back

**Download the zip** for the whole bundle plus its manifest, which hashes every
artifact. That is what goes back to the pipeline team.
